<template>
    <div class="card">
        <div class="pb-0 card-header mb-0">
            <h6>{{ title }}</h6>
            <p class="text-sm">
                <i class="fa fa-chart-bar text-success"></i>
                <span class="font-weight-bold">{{ detail1 }}</span>
                {{ detail2 }}
            </p>
        </div>
        <div class="p-3 card-body">
            <div class="chart">
                <canvas :id="chartId" class="chart-canvas" height="300"></canvas>
            </div>
        </div>
    </div>
</template>

<script>
import Chart from "chart.js/auto";

export default {
    name: "gradient-line-chart",
    props: {
        // 🛑 Propiedad para recibir el array de datos del reporte (productsalesData) 🛑
        chartData: {
            type: Array,
            default: () => [],
        },
        title: {
            type: String,
            default: "Ingresos por Producto/Servicio",
        },
        detail1: {
            type: String,
            default: "Total Recaudado",
        },
        detail2: {
            type: String,
            default: "por producto",
        },
    },
    data() {
        return {
            chartInstance: null,
            chartId: "chart-line-" + Math.random().toString(36).substring(7),
        };
    },
    watch: {
        // 🛑 Observa la data y redibuja el gráfico cuando cambie 🛑
        chartData: {
            handler: 'renderChart',
            deep: true,
            immediate: true,
        },
    },
    methods: {
        // 🛠️ Función para procesar y renderizar el gráfico 🛠️
        renderChart() {
            if (this.chartData.length === 0) {
                // Si no hay datos, destruye la instancia anterior y detén el proceso.
                if (this.chartInstance) {
                    this.chartInstance.destroy();
                    this.chartInstance = null;
                }
                return;
            }

            // 1. Destruye la instancia anterior si existe (evita errores de actualización)
            if (this.chartInstance) {
                this.chartInstance.destroy();
            }

            // 2. Extrae Etiquetas (Nombres de Productos) y Valores (Recaudación Total)
            const labels = this.chartData.map(item => item.product_service);
            const dataValues = this.chartData.map(item => parseFloat(item.total_revenue || 0));

            const ctx = document.getElementById(this.chartId).getContext("2d");
            var gradientStroke = ctx.createLinearGradient(0, 230, 0, 50);

            gradientStroke.addColorStop(1, "rgba(94, 114, 228, 0.2)");
            gradientStroke.addColorStop(0.2, "rgba(94, 114, 228, 0.0)");
            gradientStroke.addColorStop(0, "rgba(94, 114, 228, 0)");

            this.chartInstance = new Chart(ctx, {
                type: "line", // Mantenemos line, aunque bar sería mejor para productos
                data: {
                    labels: labels, // 🛑 DATA DINÁMICA 🛑
                    datasets: [
                        {
                            label: "Total Recaudado", // 🛑 TÍTULO DINÁMICO 🛑
                            tension: 0.4,
                            pointRadius: 0,
                            borderColor: "#4BB543", // Verde para ventas
                            backgroundColor: gradientStroke,
                            borderWidth: 3,
                            fill: true,
                            data: dataValues, // 🛑 DATA DINÁMICA 🛑
                            maxBarThickness: 6,
                        },
                    ],
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: {
                            display: false,
                        },
                    },
                    interaction: {
                        intersect: false,
                        mode: "index",
                    },
                    scales: {
                        y: {
                            grid: {
                                drawBorder: false,
                                display: true,
                                drawOnChartArea: true,
                                drawTicks: false,
                                borderDash: [5, 5],
                            },
                            ticks: {
                                display: true,
                                padding: 10,
                                color: "#999", // Ajustamos el color para mejor contraste
                                font: { size: 11, family: "Open Sans", style: "normal", lineHeight: 2 },
                                // Muestra el símbolo de moneda en el eje Y
                                callback: function(value) {
                                    return `$${value.toFixed(0)}`;
                                }
                            },
                        },
                        x: {
                            grid: {
                                drawBorder: false,
                                display: false,
                                drawOnChartArea: false,
                                drawTicks: false,
                                borderDash: [5, 5],
                            },
                            ticks: {
                                display: true,
                                color: "#999", // Ajustamos el color
                                padding: 20,
                                font: { size: 11, family: "Open Sans", style: "normal", lineHeight: 2 },
                            },
                        },
                    },
                },
            });
        },
    },
    // Opcional: Destruye el gráfico al salir de la vista para liberar memoria
    beforeUnmount() {
        if (this.chartInstance) {
            this.chartInstance.destroy();
        }
    }
};
</script>